export default {"src":"/_next/static/image/src/images/logo.600782c5c145422e108474e4651287dd.svg","height":17,"width":62};